import { heroType } from "types/CMS/Unum/heroBanner";
import { createResolver } from "./Factories/ResolverFactory";

export const heroTypeResolver = createResolver({
  resolve: (
    data:
      | "image_background"
      | "no_asset_left_aligned"
      | "no_asset_centre_aligned"
  ): heroType => {
    switch (data) {
      case "image_background":
        return "image";
      case "no_asset_left_aligned":
        return "noImage";
      case "no_asset_centre_aligned":
        return "centered";
      default:
        return undefined;
    }
  },
});

